<template>
  <div>
    <div class="space-y-6 mb-12 text-center">
      <h1 class="text-theme text-xl">{{ defaultVariant.title }}</h1>
      <p
        v-if="defaultVariant.product.text"
        class="max-w-sm mx-auto text-theme"
        v-html="nl2br(defaultVariant.product.text)"
      ></p>
    </div>
    <div class="flex items-center justify-center mb-7">
      <label class="text-xxs text-theme font-semibold uppercase mr-4 mt-1"
        >qty</label
      >
      <SelectMenu
        v-model.number="qty"
        :options="quantityOptions"
        :value="qty"
        themed
      />
    </div>
    <ProductAddToCartForm
      :variant="defaultVariant"
      :quantity="qty"
      :loading="false"
      class="btn-strong--alt"
    />
  </div>
</template>

<script>
import range from "ramda/src/range";
import ProductAddToCartForm from "./ProductAddToCartForm.vue";
import SelectMenu from "../ui/SelectMenu.vue";

export default {
  name: "ProductSupplies",

  components: { ProductAddToCartForm, SelectMenu },

  props: {
    defaultVariant: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      qty: Number(this.defaultVariant.minQty) || 1,
    };
  },

  computed: {
    quantityOptions() {
      const minQty = Number(this.defaultVariant.minQty || 1);
      const maxQty = Number(this.defaultVariant.maxQty || 10) + 1;

      return range(minQty, maxQty).map((v) => ({
        value: v,
        label: v,
      }));
    },
  },

  methods: { range },
};
</script>
